import { collectionCards } from "@/mocks/guaNews";

export default function Collection() {
  return (
    <section id="collection" className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
      <div className="flex items-end justify-between gap-4">
        <div>
          <h4 className="text-sm font-semibold text-primary-700">
            <a href="#collection" className="inline-flex items-center gap-1.5">
              <i className="ri-folder-chart-line text-base"></i>
              Collection
            </a>
          </h4>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">热门吃瓜合集</h2>
          <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600">
            把持续发酵的热点整理成可回看的合集，前因后果、讨论脉络一次归档，不用东拼西凑。
          </p>
        </div>
      </div>

      <div className="mt-7 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {collectionCards.map((c, i) => (
          <article
            key={i}
            className="group flex flex-col overflow-hidden rounded-2xl bg-background-100 ring-1 ring-inset ring-background-200/60 transition-all hover:-translate-y-1 hover:ring-primary-300/60"
          >
            <div className="relative overflow-hidden">
              <img
                src={c.image}
                alt={c.title}
                className="h-44 w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 whitespace-nowrap rounded-md bg-foreground-950/80 px-2 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
                合集 · {c.count}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <div className="flex flex-wrap gap-1.5">
                {c.tags.map((t) => (
                  <span key={t} className="whitespace-nowrap rounded-full bg-background-50 px-2 py-0.5 text-[11px] text-foreground-600 ring-1 ring-inset ring-background-200">
                    #{t}
                  </span>
                ))}
              </div>
              <h3 className="mt-3 font-heading text-lg font-bold leading-6 text-foreground-950 group-hover:text-primary-700">
                {c.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{c.summary}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200/70 pt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-calendar-line"></i>
                  {c.date}
                </span>
                <span className="flex items-center gap-3">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {c.views}
                  </span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-chat-3-line"></i>
                    {c.comments}
                  </span>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}